class CartOverlay extends HTMLElement {
    constructor() {
        super();
        theme?.Cart ? theme.Cart.Overlay = this : theme.Cart = {Overlay: this}
        this.FetchAndPopulateCart()
    }

    cartUpdateUnsubscriber = undefined;
    
    connectedCallback() {
        this.cartUpdateUnsubscriber = SubscribeToEvent('PopulateCart', (eventData) => {
            this.OnCartUpdated(eventData);
        });
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    async OnCartUpdated(eventData) {
        this.PopulateCart(eventData)
    }

    async FetchAndPopulateCart() {
        try {
            const result = await fetch(`${routes.cart_url}`)
            if(result.ok) {
                const text = await result.text()
                this.PopulateCart(text, false)
            } else {
                // TODO ERROR Notification Settings
                console.log('FetchAndPopulate Error:', error)
            }

        } catch (error) {
            // TODO ERROR Notification Settings
            console.log('FetchAndPopulate Error:', error)
        }
    }

    async PopulateCart(text, openOverlay = true) {
        try {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const CartSection = html.querySelector('#CartSection');
            this.innerHTML = CartSection.parentElement.innerHTML;
            InitializeGridCascades?.()
            InitializeAnimationElements?.()
        } catch (error) {
            console.error('Populate Cart Error:', error);
        }
        // Conditionally Render Overlay
        if (openOverlay) {
            theme?.Overlay?.ActivateLayer('CartLayer')
        }
        
    }
}
customElements.define('cart-overlay', CartOverlay);